import * as React from "react";

export interface Props {
  name: string;
}

export function getPortalId(name: string) {
  return `wtd-popover-portal__${name}`;
}

class PopoverPortal extends React.Component<Props> {
  public render() {
    const { name } = this.props;
    return <div id={getPortalId(name)} style={{ position: "relative" }} />;
  }
}

export default PopoverPortal;



// WEBPACK FOOTER //
// ./frontend/src/common/components/popover/PopoverPortal.tsx